export default __webpack_public_path__ + "locales/sl/Errors.json?hash=3a7ae8505d4274667a621f11699500f9";